import { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class AcademicInfo extends PureComponent {
  render() {
    return this.props.children;
  }
}

AcademicInfo.propTypes = {
  children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./containers/UserDashboard/AcademicInfo/component.jsx